import {MouseEvent, useState, useEffect, useRef} from "react";
import createClient from "openapi-fetch";
import {paths} from "../listan-backend-api";

const client = createClient<paths>();

export default function UndoRemoveButton(
    {
        listid,
        lastRemoveDoneAt,
        undoCallback,
        disabled = false,
    } : {
        listid: string,
        lastRemoveDoneAt: Date,
        undoCallback: () => void
        disabled: boolean
    }
) {
    const buttonRef = useRef<HTMLButtonElement>(null)
    const [listRemovedItemCount, setListRemovedItemCount] = useState(0);
    const [lastRemovedItemText, setLastRemovedItemText] = useState("");
    const [listHasRemovedItems, setListHasRemovedItems] = useState(false);
    const [lastUndoRemoveDoneAt, setLastUndoRemoveDoneAt] = useState(new Date());

    useEffect(() => {
        client.GET("/api/list/{listid}/removed_items", {
            params: {
                path: {
                    listid: listid
                }
            }
        })
            .then((response) => {
                if (
                    response.data
                    && response.response.ok
                    && response.data.items.length > 0
                ) {
                    setListHasRemovedItems(true);
                } else {
                    setListHasRemovedItems(false);
                }

                if (
                    response.data
                    && response.response.ok
                ) {
                    setListRemovedItemCount(response.data.items.length);
                    setLastRemovedItemText(response.data.items[0]?.text)
                }
            })
            .catch(console.error)
    }, [lastRemoveDoneAt, lastUndoRemoveDoneAt, listid])

    const undoRemoveClickHandler = (event: MouseEvent<HTMLButtonElement>) => {
        client.POST("/api/list/{listid}/undo_last_removed_item", {
            params: {
                path: {
                    listid: listid
                }
            }
        }).then((response) => {
            if (response.response.ok) {
                setLastUndoRemoveDoneAt(new Date());
                undoCallback();
            }
        }).catch(console.error);
    };

    return (
        <>
            <button ref={buttonRef} className={"undoRemoveButton"} onClick={undoRemoveClickHandler} disabled={!listHasRemovedItems || disabled}>Ångra </button>
        </>
    );
}
